import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { CountryFlagImage } from './components/CountryFlagImage';
import { CountryFlagShadow } from './components/CountryFlagShadow';
export var CountryFlag = styled(function (_a) {
    var variant = _a.variant, className = _a.className;
    return (React.createElement("span", { className: className },
        React.createElement(CountryFlagImage, { variant: variant }),
        React.createElement(CountryFlagShadow, null)));
})(function (_a) {
    var size = _a.size;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: inline-block;\n\n    width: 1.46em;\n    height: 1.46em;\n\n    ", "\n\n    flex-grow: 0;\n\n    border-radius: 50%;\n\n    vertical-align: text-bottom;\n    overflow: hidden;\n  "], ["\n    position: relative;\n    display: inline-block;\n\n    width: 1.46em;\n    height: 1.46em;\n\n    ",
        "\n\n    flex-grow: 0;\n\n    border-radius: 50%;\n\n    vertical-align: text-bottom;\n    overflow: hidden;\n  "])), size && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-size: ", "rem;\n      "], ["\n        font-size: ", "rem;\n      "])), size));
});
CountryFlag.propTypes = {
    className: PropTypes.string,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=CountryFlag.js.map